import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import dayjs from "dayjs";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useState } from "react";
import isToday from "dayjs/plugin/isToday";
import HelpLink from "../../help/HelpLink";

dayjs.extend(isToday);

const MILLISECONDS_IN_HOUR = 60 * 60 * 1000;

const DeadlineContainer = ({
  hasDeadline,
  setHasDeadline,
  setDeadline,
  deadline,
  isRecurring,
  setRecurring,
  setFrequency,
}) => {
  const [error, setError] = useState(null);

  const errorMessage = React.useMemo(() => {
    switch (error) {
      case "minDate":
      case "minTime": {
        return "Your deadline cannot be in the past";
      }

      case "invalidDate": {
        return "Please enter a valid date";
      }

      default: {
        return "";
      }
    }
  }, [error]);

  const onDeadlineContainerClick = () => {
    if (!hasDeadline) {
      setHasDeadline(true);
      const currentTime = dayjs();
      const roundedTime = dayjs(
        Math.ceil(currentTime.valueOf() / MILLISECONDS_IN_HOUR) *
          MILLISECONDS_IN_HOUR,
      );
      setDeadline(roundedTime);

      if (isRecurring) {
        setRecurring(false);
      }
    }
  };

  return (
    <div className="deadline-container" onClick={onDeadlineContainerClick}>
      <div style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
        <HelpLink
          to="/about/features/tasks/deadlines"
          size="small"
          sx={{ ml: -1.5 }}
        />
        <FormControlLabel
          label=""
          control={
            <Checkbox
              label="Deadline"
              checked={!!hasDeadline}
              onChange={(event) => {
                const checked = event.target.checked;
                if (checked) {
                  const currentTime = dayjs();
                  const roundedTime = dayjs(
                    Math.ceil(currentTime.valueOf() / MILLISECONDS_IN_HOUR) *
                      MILLISECONDS_IN_HOUR,
                  );
                  setDeadline(roundedTime);
                  setFrequency(undefined);
                } else {
                  setDeadline(undefined);
                }

                setHasDeadline(checked);
              }}
            />
          }
        />
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          minTime={deadline && deadline.isToday() ? dayjs() : null}
          renderInput={(props) => (
            <TextField {...props} helperText={errorMessage} />
          )}
          label={hasDeadline ? "Deadline" : "No deadline"}
          disablePast={true}
          value={deadline === undefined ? null : deadline}
          onChange={(newDeadline) => {
            if (dayjs(newDeadline) < dayjs()) {
              const currentTime = dayjs();
              const roundedTime = dayjs(
                Math.ceil(currentTime.valueOf() / MILLISECONDS_IN_HOUR) *
                  MILLISECONDS_IN_HOUR,
              );
              setDeadline(roundedTime);
            } else {
              setDeadline(newDeadline);
            }
          }}
          disabled={!hasDeadline}
          onError={(newError) => setError(newError)}
          ampm={false}
          inputFormat={"DD/MM/YYYY HH:mm"}
          views={["year", "month", "day", "hours"]}
          shouldDisableYear={(year) => year.isBefore(dayjs(), "year")}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DeadlineContainer;
